import { z } from "zod";

export const emailAddressSchema = z.object({
    id: z.number(),
    idUUID: z.string(),
    emailType: z.string().optional().nullable(),
    emailAddress: z.string().optional().nullable(),
    primary: z.string().optional().nullable(),
});
